const DoctorProfile = () =>
    import ( /* webpackChunkName: "DoctorProfile" */ "@/components/profile/doctor/DoctorProfile");
import DoctorRoutes from "./Doctor";

export default [
    {
        path: "",
        redirect: {
            name: "DoctorProfile",
            params: {
                doctorId: 1
            }
        }
    },
    {
        path: "doctor/:doctorId",
        name: "profile.doctor",
        redirect: {
            name: "profile.doctor.time-fees"
        },
        component: DoctorProfile,
        children: DoctorRoutes
    },
];